import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $('#optional-fields').on('show.bs.modal', () => {
      let offCanvas = $(document.querySelector('#filters-canvas')).data('offcanvas-component');
      offCanvas.close();
    });
  }
}